// Toggles between the Add to Cart button and the "this product will not be restocked" message
// (see snippets/back-in-stock-trigger.liquid) live on the theme's native "variant:change" event,
// for both the native buy box (buy-buttons.liquid) and the volume/bundle selector widget.
//
// Only relevant for exit-tagged (end-of-life) products: the two elements this toggles between
// are only ever rendered when the product is exit-tagged, so this is a no-op everywhere else.
// Every other sold-out product is handled entirely by Klaviyo's own native Back in Stock
// feature (Signup Forms > Back in Stock, configured there to exclude the `exit` tag) acting
// directly on the native Add to Cart button - no theme code needed for that case.
(function () {
  document.addEventListener('variant:change', (event) => {
    const formId = event.target.getAttribute('id');
    if (!formId) return;

    // buy-buttons.liquid's wrapper carries form="{formId}"; the volume selector's own form
    // simply *is* that id (see CUSTOMIZATIONS.md's volume-selector formId-shadowing fix).
    document.querySelectorAll(`buy-buttons[form="${formId}"], .volume-selector[data-product-form-id="${formId}"]`).forEach((container) => {
      const addToCart = container.querySelector('.buy-buttons__add-to-cart, .volume-selector__add-to-cart');
      const backInStock = container.querySelector('.buy-buttons__back-in-stock, .volume-selector__back-in-stock');
      if (!addToCart || !backInStock) return;

      try {
        addToCart.hidden = !event.detail.variant.available;
        backInStock.hidden = event.detail.variant.available;
      } catch (error) {
        console.error('back-in-stock: failed to update trigger', error);
      }
    });
  });
})();
